// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  min-height: 47px;
  height: 47px;
}

i.fas {
  font-size: 1.2rem;
}

.separador {
  display: block;
  border-top: 1px rgb(228, 228, 228) solid;
  margin: 0 !important;
  padding: 0 !important;
}

.sucursal {
  border-bottom: 1px rgb(228, 228, 228) solid;
  background-color: white;
  cursor: pointer;
  margin-bottom: 0 !important;
  padding-left: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.sucursal .check {
  display: none;
}
.sucursal.actual {
  background-color: #38caff !important;
  color: white !important;
}
.sucursal.actual:hover {
  background-color: #38caff !important;
  color: white !important;
}
.sucursal.actual .check {
  display: block;
  color: white !important;
  right: 0 !important;
  float: right !important;
  text-align: end !important;
  font-size: 2rem !important;
  margin-right: 20px !important;
}
.sucursal.actual .check i.fas {
  font-size: 2rem !important;
}
.sucursal .detalle {
  font-size: 0.85rem;
}
.sucursal:hover {
  background-color: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/sucursales/components/sucursales-selecciona/sucursales-selecciona.component.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,YAAA;AACD;;AACA;EACC,iBAAA;AAED;;AACA;EACC,cAAA;EACA,wCAAA;EACA,oBAAA;EACA,qBAAA;AAED;;AAAA;EACC,2CAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAGD;AAFC;EACC,aAAA;AAIF;AADC;EACC,oCAAA;EACA,uBAAA;AAGF;AADE;EACC,oCAAA;EACA,uBAAA;AAGH;AAAE;EACC,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;AAEH;AADG;EACC,0BAAA;AAGJ;AAEC;EACC,kBAAA;AAAF;AAGC;EACC,yBAAA;AADF","sourcesContent":["button {\r\n\tmin-height: 47px;\r\n\theight: 47px;\r\n}\r\ni.fas {\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.separador {\r\n\tdisplay: block;\r\n\tborder-top: 1px rgb(228, 228, 228) solid;\r\n\tmargin: 0 !important;\r\n\tpadding: 0 !important;\r\n}\r\n.sucursal {\r\n\tborder-bottom: 1px rgb(228, 228, 228) solid;\r\n\tbackground-color: white;\r\n\tcursor: pointer;\r\n\tmargin-bottom: 0 !important;\r\n\tpadding-left: 10px;\r\n\tpadding-top: 8px;\r\n\tpadding-bottom: 8px;\r\n\t.check {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t&.actual {\r\n\t\tbackground-color: #38caff !important;\r\n\t\tcolor: white !important;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: #38caff !important;\r\n\t\t\tcolor: white !important;\r\n\t\t}\r\n\r\n\t\t.check {\r\n\t\t\tdisplay: block;\r\n\t\t\tcolor: white !important;\r\n\t\t\tright: 0 !important;\r\n\t\t\tfloat: right !important;\r\n\t\t\ttext-align: end !important;\r\n\t\t\tfont-size: 2rem !important;\r\n\t\t\tmargin-right: 20px !important;\r\n\t\t\ti.fas{\r\n\t\t\t\tfont-size: 2rem !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.detalle {\r\n\t\tfont-size: 0.85rem;\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #f9f9f9;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
